export default Symbol('ReduxStore');
